import { useEffect, useRef, useState } from 'react';
import { LESSON_SCENE_MAP } from '../../constants/types/free-trial/type';

export const useFreeTrialLessonAudio = () => {
  const audioRef = useRef<HTMLAudioElement | null>(null);

  const [audioProgress, setAudioProgress] = useState(0);
  const [isAudioPlaying, setIsAudioPlaying] = useState(false);

  const stopAudio = () => {
    const audio = audioRef.current;

    if (!audio) return;

    audio.pause();
    audio.currentTime = 0;
    audio.onended = null;
    audio.ontimeupdate = null;

    setAudioProgress(0);
    setIsAudioPlaying(false);
  };

  const playAudio = (src: string) => {
    playAudioSequence([src]);
  };

  const playAudioSequence = (audios: string[], onEnded?: () => void) => {
    if (audios.length === 0) return;

    stopAudio();

    const audio = audioRef.current ?? new Audio();
    audioRef.current = audio;

    let index = 0;

    audio.ontimeupdate = () => {
      if (!audio.duration) return;

      setAudioProgress((audio.currentTime / audio.duration) * 100);
    };

    const playNext = () => {
      const src = audios[index];

      if (!src) {
        audio.onended = null;

        setAudioProgress(100);
        setIsAudioPlaying(false);

        onEnded?.();
        return;
      }

      index += 1;

      setAudioProgress(0);

      audio.src = src;
      audio.currentTime = 0;

      void audio
        .play()
        .then(() => {
          setIsAudioPlaying(true);
        })
        .catch((error) => {
          setIsAudioPlaying(false);
          console.error('음원 재생 실패', error);
        });
    };

    audio.onended = playNext;

    playNext();
  };

  const playSceneAudio = (step: number, index: number) => {
    const scene = LESSON_SCENE_MAP[step]?.[index];

    if (!scene || !('audios' in scene) || !scene.audios?.length) {
      stopAudio();
      return;
    }

    playAudioSequence(scene.audios);
  };

  useEffect(() => {
    return () => {
      const audio = audioRef.current;

      if (!audio) return;

      audio.pause();
      audio.onended = null;
      audio.ontimeupdate = null;
      audio.src = '';

      audioRef.current = null;
    };
  }, []);

  return {
    stopAudio,
    playAudio,
    playSceneAudio,
    audioProgress,
    isAudioPlaying,
  };
};
